<template>
  <div>
    <check-selector-collapse
      :icon="icon"
      :label="label"
      :options="options"
      @checked="handleChecked"
    />
  </div>
</template>

<script>
import CheckSelectorCollapse from '../../../../commons/forms/CheckSelectorCollapse.vue';
import catalogoSellout from '@/api/catalogoSellout.api';
import { mapActions } from 'vuex';
import { mapState } from 'vuex';

export default {
  name: 'CategoriaSelector',
  components: { CheckSelectorCollapse },
  extends: catalogoSellout,
  props: {
    label: {
      type: String,
      default: 'Categorías',
    },
    icon: {
      type: String,
      default: 'icon-pharmacy',
    },
  },
  data() {
    return {
      options: [],
      selectedItems: [],
      selectedItemsSet: new Set(),
    };
  },
  computed: {
    ...mapState('filters', ['filtros']),
  },
  watch: {
    'filtros.categorias': function () {
      this.syncSelectedItemsWithStore();
    },
  },
  mounted() {
    this.loadItems();
  },
  methods: {
    loadItems() {
      let loadPromise = new Promise((resolve) => {
        this.getCategorias(resolve, this.request);
      });

      loadPromise.then((data) => {
        this.options = data.map((item) => ({
          text: item.categoria,
          value: item.id_categoria,
          selected: false,
        }));
      });
    },
    syncSelectedItemsWithStore() {
      const categoriasSeleccionadas = this.filtros.categorias || [];

      const selectedItemsSet = new Set();

      categoriasSeleccionadas.forEach((categoria) => {
        selectedItemsSet.add(String(categoria.codigo));
        selectedItemsSet.add(String(categoria.value));
      });

      this.options = this.options.map((item) => {
        item.selected = selectedItemsSet.has(String(item.value));
        return item;
      });
    },
    handleChecked(newSelectedItems) {
      const categoriasSeleccionadas = this.filtros.categorias || [];

      if (!Array.isArray(newSelectedItems)) {
        newSelectedItems = [newSelectedItems];
      }

      newSelectedItems.forEach((selected) => {
        const valueToCheck = String(selected.value);

        if (selected.selected) {
          this.selectedItemsSet.add(valueToCheck);
        } else {
          this.selectedItemsSet.delete(valueToCheck);
        }
      });

      let selectedItemsArray = Array.from(this.selectedItemsSet);

      categoriasSeleccionadas.forEach((item) => {
        const valueToCheck = item.value
          ? String(item.value)
          : String(item.codigo);

        if (!selectedItemsArray.includes(valueToCheck)) {
          selectedItemsArray.push(valueToCheck);
        }
      });

      newSelectedItems.forEach((selected) => {
        if (!selected.selected) {
          const valueToCheck = String(selected.value);
          selectedItemsArray = selectedItemsArray.filter(
            (item) => item !== valueToCheck
          );
        }
      });

      const selectedItems = selectedItemsArray.map((value) => ({
        value,
        selected: true,
      }));

      this.updateFiltros({
        filtro: 'categorias',
        items: selectedItems,
      });
    },

    ...mapActions('filters', ['updateFiltros']),
  },
};
</script>
